import { render, staticRenderFns } from "./CreateOrEditReference.vue?vue&type=template&id=048e44c0&scoped=true"
import script from "./CreateOrEditReference.vue?vue&type=script&lang=js"
export * from "./CreateOrEditReference.vue?vue&type=script&lang=js"
import style0 from "./CreateOrEditReference.vue?vue&type=style&index=0&id=048e44c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e44c0",
  null
  
)

export default component.exports